import css from './searchbox.module.scss';
import {SearchboxProps} from './searchbox.types';

export const Searchbox = ({placeholder, onValueChange}: SearchboxProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.iconContainer}>
				<img src="img/magnifyIcon.svg" />
			</div>
			<input
				placeholder={placeholder}
				onChange={(ev) => onValueChange(ev.target.value)}
				className={css.input}
				type="search"
			></input>
		</div>
	);
};
